<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <div class="page-title page-title--columns">
            <div class="page-title__left">
              <p class="page-title__link-back" i18n *ngIf="!loading"><a
                  routerLink="/contracts">Contrato {{
                  contract?.code }} - {{ contract?.name }}</a></p>
              <h2 i18n>Configurações Gerais</h2>
            </div>
          </div>
          <section *ngIf="!loading">
            <div [id]="'userIdHistoryUnfoldRegulation'">
              <!-- Enquadramentos habilitados -->
              <div class="table-hover table-block mb-1">
                <div class="d-flex flex-row justify-content-between"
                  style="cursor: pointer;">
                  <div class="col mt-3" style="font-size: 20px;"
                    (click)="unfoldMoreOrLessRegulation()">
                    <h5 class="mb-3" i18n><strong>Habilitar no contrato os
                        enquadramentos abaixo</strong>:</h5>
                  </div>
                  <div class="p-3">
                    <button type="button"
                      class="btn text-secondary btn-icon-block"
                      (click)="unfoldMoreOrLessRegulation()">
                      <i class="material-icons"
                        *ngIf="typeUnfoldRegulation === 'less'; else elseBlockTable">unfold_less</i>
                      <ng-template #elseBlockTable>
                        <i class="material-icons">unfold_more</i>
                      </ng-template>
                    </button>
                  </div>
                </div>
                <div *ngIf="typeUnfoldRegulation === 'more'"
                  class="limited-height noOverFlow">
                  <div class="card card-body">
                    <form [formGroup]="regulationForm" class="pb-1">
                      <table
                        class="table table-sm table-borderless text-center table-striped">
                        <thead>
                          <th class="titleTh"
                            i18n><strong>Enquadramento</strong></th>
                          <th class="titleTh" i18n><strong>Cor</strong></th>
                          <th></th>
                        </thead>
                        <tbody class="table-hover align-items-center">
                          <tr
                            *ngFor="let regulation of regulationForm.get('regulationsCheck')['controls']; let i = index"
                            class="row-item">
                            <td>
                              <div [formGroup]="regulation">
                                <app-input type="select" [list]="regulations"
                                  formControlName="regulationId"
                                  placeholder="Selecione um enquadramento"
                                  selectText="shortDescription"
                                  selectValue="id"
                                  hasLabel=false
                                  (ngModelChange)="checkDoubleRegulation($event, i)"
                                  i18n-placeholder i18n-label
                                  inputRequired="true">
                                </app-input>
                              </div>
                            </td>
                            <td>
                              <div [formGroup]="regulation"
                                class="color-content">
                                <app-input i18n-label="@@Color" type="color"
                                  class="form-color"
                                  inputRequired="true" hasLabel=false
                                  (change)="updateColor($event, i)"
                                  formControlName="color">
                                </app-input>
                              </div>
                            </td>
                            <td>
                              <div [formGroup]="regulation">
                                <button
                                  *appPermission="['UpdateContractSettings']; contracts: contract && [contract.id]"
                                  class="btn text-secondary btn-icon-block"
                                  data-placement="top" i18n-appTooltip
                                  appTooltip="Apagar registro"
                                  (click)="removeRegulation(i, regulation.value.id)">
                                  <i
                                    class="material-icons">remove_circle_outline</i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </form>
                    <div class="row">
                      <div class="col-12">
                        <button type="button" class="btn btn-fade-info mt-3"
                          (click)="addRegulation()">
                          Adicionar Novo
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- fim Enquadramentos habilitados -->
            <hr>
            <!-- Gerar QRCode -->
            <div [id]="'userIdHistoryUnfoldQrCode'">
              <div class="table-responsive table-hover table-block mb-1">
                <div class="d-flex flex-row justify-content-between"
                  style="cursor: pointer;">
                  <div class="col mt-3" style="font-size: 20px;"
                    (click)="unfoldMoreOrLessQrCode()">
                    <h5 class="pt-1 mb-3" i18n><strong>Gerar
                        QRCode</strong>:</h5>
                  </div>
                  <div class="p-3">
                    <button type="button"
                      class="btn text-secondary btn-icon-block"
                      (click)="unfoldMoreOrLessQrCode()">
                      <i class="material-icons"
                        *ngIf="typeUnfoldQrCode === 'less'; else elseBlockQrCode">unfold_less</i>
                      <ng-template #elseBlockQrCode>
                        <i class="material-icons">unfold_more</i>
                      </ng-template>
                    </button>
                  </div>
                </div>
                <div *ngIf="typeUnfoldQrCode === 'more'" class="limited-height">
                  <form [formGroup]="qrcodeForm" class="pb-1">
                    <div class="form-group pl-4">
                      <input class="form-check-input" type="checkbox"
                        formControlName="enabledQRCode"
                        [ngClass]="{ 'disabled': !allowEdit }">
                      <label for="enabledQRCode"
                        [ngClass]="{'disabled': !allowEdit}" i18n>Habilitar
                        geração do
                        QRCode:</label>
                      <i i18n-appTooltip
                        class="material-icons icon-sm text-secondary"
                        appTooltip="Caso essa opção esteja habilitada, o sistema irá gerar um QRCode para acesso ao vídeo das infrações dos enquadramentos selecionados abaixo.">help</i>
                    </div>
                    <div class="form-group"
                      *ngIf="qrcodeForm.get('enabledQRCode').value">
                      <app-input i18n-label i18n-placeholder
                        placeholder="Selecione os enquadramentos"
                        label="Enquadramentos" type="multiselect"
                        selectText="shortDescription" selectValue="id"
                        [list]="enabledRegulations"
                        formControlName="regulationIds"
                        [inputDisabled]="!allowEdit"
                        selectShowLimit="5"
                        (click)="openViewSelectListModal(qrcodeForm.get('regulationIds').value, 'Enquadramentos', !allowEdit, enabledRegulations)">
                      </app-input>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- fim Gerar QRCode -->
            <hr>
            <!-- Fabricante/Modelo do Equipamento -->
            <div [id]="'userIdHistoryUnfoldEquipModel'">
              <div class="table-responsive table-hover table-block mb-1">
                <div class="d-flex flex-row justify-content-between"
                  style="cursor: pointer;">
                  <div class="col mt-3" style="font-size: 20px;"
                    (click)="unfoldMoreOrLessEquipModel()">
                    <h5 class="my-4" i18n><strong>Fabricante/Modelo do
                        Equipamento</strong></h5>
                  </div>
                  <div class="p-3">
                    <button type="button"
                      class="btn text-secondary btn-icon-block"
                      (click)="unfoldMoreOrLessEquipModel()">
                      <i class="material-icons"
                        *ngIf="typeUnfoldEquipModel === 'less'; else elseBlockEquipModel">unfold_less</i>
                      <ng-template #elseBlockEquipModel>
                        <i class="material-icons">unfold_more</i>
                      </ng-template>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="typeUnfoldEquipModel === 'more'"
                class="limited-height">
                <table
                  class="table table-sm table-borderless text-center table-striped">
                  <thead>
                    <th i18n>Fabricante</th>
                    <th i18n>Modelo de Equipamento</th>
                    <th i18n>Tipo</th>
                    <th i18n>Categoria</th>
                    <th></th>
                  </thead>
                  <tbody class="table-hover align-items-center">
                    <tr *ngFor="let equipmentId of contract?.equipmentModelIds">
                      <td class="align-middle"
                        *ngIf="equipmentId !== 0">{{manufacturerById
                        &&
                        manufacturerById[equipmentModelsById[equipmentId]?.manufacturerId]?.name
                        || '-' }}</td>
                      <td
                        class="align-middle"
                        *ngIf="equipmentId !== 0">{{equipmentModelsById[equipmentId]?.name
                        || '-' }}</td>
                      <td class="align-middle" *ngIf="equipmentId !== 0">
                        <span i18n>{{ equipmentModelsById[equipmentId]?.type ||
                          '-' }}</span>
                      </td>
                      <td class="align-middle" *ngIf="equipmentId !== 0">
                        <span i18n>{{ equipmentModelsById[equipmentId]?.category
                          || '-' }}</span>
                      </td>
                      <td *ngIf="equipmentId !== 0">
                        <button
                          *appPermission="['UpdateContractSettings']; contracts: contract && [contract.id]"
                          class="btn text-secondary btn-icon-block"
                          data-placement="top" i18n-appTooltip
                          appTooltip="Apagar registro"
                          (click)="removeModel(equipmentId)">
                          <i class="material-icons">remove_circle_outline</i>
                        </button>
                      </td>
                    </tr>
                    <tr *ngFor="let form of manufacturerModelForms"
                      [formGroup]="form">
                      <td class="align-middle text-center">
                        <app-input type="select"
                          formControlName="manufacturerId"
                          [list]="manufacturers"
                          placeholder="Selecione um fabricante"
                          class="no-margin w-75" inputRequired=true
                          hasLabel=false
                          selectText="name" selectValue="id"
                          i18n-placeholder></app-input>
                      </td>
                      <td class="align-middle text-center">
                        <app-input type="select"
                          formControlName="equipmentModelId"
                          [list]="equipments[form.value.manufacturerId]"
                          placeholder="Selecione um equipamento"
                          class="no-margin w-75" selectText="name"
                          selectValue="id" inputRequired=true hasLabel=false
                          [inputDisabled]="form.value.manufacturerId === ''"
                          i18n-placeholder></app-input>
                      </td>
                      <td class="align-middle text-center">
                        <app-input type="select"
                          formControlName="equipmentModelType"
                          [list]="equipments[form.value.manufacturerId]"
                          class="no-margin w-75 textDesable"
                          selectText="type" selectValue="id" hasLabel=true
                          [inputDisabled]="form.value.equipmentModelId === ''"></app-input>
                      </td>
                      <td class="align-middle text-center">
                        <app-input type="select"
                          formControlName="equipmentModelCategory"
                          [list]="equipments[form.value.manufacturerId]"
                          class="no-margin w-75 textDesable"
                          selectText="category" selectValue="id"
                          placeholder="Selecione a categoria"
                          [inputDisabled]="form.value.equipmentModelId === ''"></app-input>
                      </td>
                      <td>
                        <button [routerLink]
                          *appPermission="['UpdateContractSettings']; contracts: contract && [contract.id]"
                          class="btn text-secondary btn-icon-block"
                          data-placement="top" i18n-appTooltip
                          appTooltip="Apagar registro"
                          (click)="removeForm(form)">
                          <i class="material-icons">remove_circle_outline</i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <button class="btn btn-fade-info mt-3" (click)="addNewModel()"
                  *appPermission="['UpdateContractSettings']; contracts: contract && [contract.id]">
                  Adicionar novo
                </button>
                <hr>
              </div>
            </div>
            <!-- fim Fabricante/Modelo do Equipamento -->
            <!-- Importação de Arquivos -->
            <hr>
            <div>
              <div class="table-responsive table-hover table-block mb-1">
                <div class="d-flex flex-row justify-content-between"
                  style="cursor: pointer;">
                  <div class="col mt-3" style="font-size: 20px;">
                    <h5 class="mb-3" i18n><strong>Importação de
                        Arquivos</strong>:</h5>
                    <form [formGroup]="enabledImportForm">
                      <!--Habilitar Importação -->
                      <div class="form-group pl-4">
                        <input class="primary form-check-input" type="checkbox"
                          formControlName="enabledImportFile"
                          [ngClass]="{ 'disabled': !allowEdit }">
                        <label for="enabledImportFile"
                          [ngClass]="{'disabled': !allowEdit}" i18n>Habilitar
                          Importação de
                          Arquivos:</label>
                      </div>
                      <!-- fim Habilitar Importação -->
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <!-- Configuração do client -->
            <div [id]="'userIdHistoryUnfoldClientCode'">
              <div class="table-responsive table-hover table-block mb-1">
                <div class="d-flex flex-row justify-content-between"
                  style="cursor: pointer;">
                  <div class="col mt-3" style="font-size: 20px;"
                    (click)="unfoldMoreOrLessClientCode()">
                    <h5 class="mb-3" i18n>
                      <strong>Configurações do cliente:</strong>
                    </h5>
                  </div>
                  <div class="p-3">
                    <button type="button"
                      class="btn text-secondary btn-icon-block"
                      (click)="unfoldMoreOrLessClientCode()">
                      <i class="material-icons"
                        *ngIf="typeUnfoldClientCode === 'less'; else elseBlockClientCode">unfold_less</i>
                      <ng-template #elseBlockClientCode>
                        <i class="material-icons">unfold_more</i>
                      </ng-template>
                    </button>
                  </div>
                </div>
                <div *ngIf="typeUnfoldClientCode === 'more'"
                  class="limited-height">
                  <div class="card-body">
                    <div class="toggle-panel card card-bordered mt-4"
                      *ngFor="let form of clientCodesForms; index as i">
                      <div class="card-body">
                        <form [formGroup]="form.selectionForm">
                          <div class="mt-2 text-right">
                            <button class="btn btn-icon-block text-secondary"
                              (click)="removeClientForm(i)">
                              <i class="material-icons" i18n-appTooltip
                                appTooltip="Remover configuração">remove_circle</i></button>
                          </div>
                          <div class="row">
                            <div class="col">
                              <app-input i18n-label type="text"
                                label="Código do Cliente"
                                placeholder="Digite o codigo do cliente"
                                formControlName="code"
                                toolTipMsg='Código interno utilizado pelo cliente'>
                              </app-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-6 col-sm-3">
                              <div class="form-group">
                                <div class="dtInicial">
                                  <app-input type="date" class="dtInicial"
                                    formControlName="startDate"
                                    inputRequired=true label="Data Inicial"
                                    toolTipMsg="Em caso de um novo codigo do cliente a data final do período anterior tem que ser preenchido.
                                    E o novo período precisar ser diferente do período anterior">
                                  </app-input>
                                </div>
                              </div>
                            </div>
                            <div class="col-6 col-sm-3">
                              <div class="form-group">
                                <label i18n>Hora Inicial: <small
                                    class="text-danger">*</small></label>
                                <app-input class="no-margin small"
                                  format="dd:dd:dd" formControlName="startHour"
                                  inputRequired=true hasLabel=false>
                                </app-input>
                              </div>
                            </div>
                            <div class="col-6 col-sm-3">
                              <div class="form-group">
                                <label i18n>Data Final: </label>
                                <app-input type="date" class="no-margin small"
                                  formControlName="endDate"
                                  hasLabel=false>
                                </app-input>
                              </div>
                            </div>
                            <div class="col-6 col-sm-3">
                              <div class="form-group">
                                <label i18n>Hora Final: </label>
                                <app-input class="no-margin small"
                                  format="dd:dd:dd" formControlName="endHour"
                                  hasLabel=false>
                                </app-input>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="mt-2 text-left">
                      <button (click)="addNew()"
                        *appPermission="['UpdateContractSettings']; contracts: contract && [contract.id]"
                        class="btn btn-fade-info">
                        Adicionar novo</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div [id]="'userIdHistoryUnfoldRegulator'">
              <div class="table-responsive table-hover table-block mb-1">
                <div class="d-flex flex-row justify-content-between"
                  style="cursor: pointer;">
                  <div class="col mt-3" style="font-size: 20px;"
                    (click)="unfoldMoreOrLessRegulator()">
                    <h5 class="mb-3" i18n><strong>Dados do Orgão
                        Regulamentador</strong>:</h5>
                  </div>
                  <div class="p-3">
                    <button type="button"
                      class="btn text-secondary btn-icon-block"
                      (click)="unfoldMoreOrLessRegulator()">
                      <i class="material-icons"
                        *ngIf="typeUnfoldRegulator === 'less'; else elseBlockRegulator">unfold_less</i>
                      <ng-template #elseBlockRegulator>
                        <i class="material-icons">unfold_more</i>
                      </ng-template>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="typeUnfoldRegulator === 'more'"
                class="limited-height">
                <form [formGroup]="regulatorForm">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-4">
                        <app-input i18n-label type="text"
                          label="Código do Orgão Regulamentador"
                          formControlName="regulatorCode">
                        </app-input>
                      </div>
                      <div class="col-4">
                        <app-input i18n-label type="text"
                          label="Nome do Orgão Regulamentador"
                          formControlName="regulatorName">
                        </app-input>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4">
                        <app-input i18n-label type="text"
                          label="Código do Agente Regulamentador"
                          formControlName="regulatorAgentCode">
                        </app-input>
                      </div>
                      <div class="col-4">
                        <app-input i18n-label type="text"
                          label="Nome do Agente Regulamentador"
                          formControlName="regulatorAgentName">
                        </app-input>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <hr>
            <div [id]="'userIdHistoryUnfoldFiles'">
              <div class="table-responsive table-hover table-block mb-1">
                <div class="d-flex flex-row justify-content-between"
                  style="cursor: pointer;">
                  <div class="col mt-3" style="font-size: 20px;"
                    (click)="unfoldMoreOrLessFiles()">
                    <h5 class="mb-3" i18n><strong>Arquivos</strong>:</h5>
                  </div>
                  <div class="p-3">
                    <button type="button"
                      class="btn text-secondary btn-icon-block"
                      (click)="unfoldMoreOrLessFiles()">
                      <i class="material-icons"
                        *ngIf="typeUnfoldFiles === 'less'; else elseBlockFiles">unfold_less</i>
                      <ng-template #elseBlockFiles>
                        <i class="material-icons">unfold_more</i>
                      </ng-template>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="typeUnfoldFiles === 'more'" class="limited-height">
                <form [formGroup]="importFilesForm">
                  <div class="card-body">
                    <app-file-upload i18n-text="@@TextSingleLabel"
                      formControlName="files" [files]=files
                      (outputFiles)="files = $event"
                      accept="image/jpg, image/jpeg, image/png, image/gif, video/mp4, video/mpeg, application/doc, application/docx, application/pdf"
                      text="Você pode selecionar no máximo até 3 arquivos."
                      limit="3"></app-file-upload>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
        <hr>
        <div class="loading-page" *ngIf="loading">
          <div class="loading-spinner">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex justify-content-end mt-3">
        <a routerLink="/contracts"><button
            class="btn btn-outline-secondary mr-3">Cancelar</button></a>
        <button class="btn btn-primary" (click)="confirmation()"
          [disabled]="!allowEdit || !isValid">
          <span *ngIf="!isLoading">Confirmar</span>
          <div class="loading-spinner" *ngIf="isLoading">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </button>
      </div>
    </div>
  </div>
</div>
